import { Calendar } from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";

export class MonthCalendar {
  static generate() {
    let calendarEl = document.getElementById("month-calendar");
    if (calendarEl == null) { return }
    let calendarEvents = $('#calendar-events').data('events');
    let date = $('#calendar-date').data('date');

    let calendar = new Calendar(calendarEl, {
      plugins: [dayGridPlugin],
      initialDate: date,
      headerToolbar:{ left: 'title', center: '', right: '' },
      height: "auto",
      fixedWeekCount: false,
      events: calendarEvents,
      eventContent: this._eventContent(),
      locale: "ja",
      dayCellContent: function (e) {
        e.dayNumberText = e.dayNumberText.replace('日', '');
      }
    });

    calendar.render();

    return calendar;
  }

  static _eventContent() {
    return function(arg) {
      let title = arg.event.title
      let extendedProps = arg.event.extendedProps
      let newArrival = !!(extendedProps.is_new_arrival) ? `<p>●(新着)</p>` : '';
      let eventContent = `
        ${newArrival}
        <p>${title}</p>
      `;
      return {html: eventContent}
    }
  };
}
